<div class="market-container" id="market-container">
  <div *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>

  <div class="market-menu flex">
    <div class="button-container">
      <button mat-raised-button class="contrast-button" *ngIf="!isUserLoggedIn" [routerLink]="'/Login'">{{'logIn' | translate}}</button>
      <button mat-raised-button class="contrast-button" *ngIf="isUserLoggedIn" [routerLink]="'/MyAccount'">{{'myAccount' | translate}}</button>
    </div>
    <div class="dropdown-container">
      <mat-form-field>
        <mat-label>{{'artists' | translate}}</mat-label>
        <mat-select [(value)]="selectedArtistId" (selectionChange)="selectionChangeArtistId($event.value.toString())">
          <mat-option *ngFor="let artist of artists" [value]="artist.id">
            {{artist.full_name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{'categories' | translate}}</mat-label>
        <mat-select [(value)]="selectedCategoryId" (selectionChange)="selectionChangeCategoryId($event.value.toString())">
          <mat-option *ngFor="let artCategory of categories" [value]="artCategory.id">
            {{artCategory.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </div>

  <div class="art-objects-wrapper">
    <div *ngFor="let art of artObjects" class="art-object lazy-load hidden" #lazyElement (click)="seeDetails('1', art.id.toString())">
      <img [src]="backendAddress + art.file_path">
      <button mat-button class="transparent-button">{{'seeDetails' | translate}}</button>
    </div>
    <p *ngIf="artObjects.length <= 0">{{'noResultsFound' | translate}}</p>
  </div>

  <p class="seo-descr">
    {{'marketSeoDescr' | translate}}
  </p>
</div>
